module.exports = __webpack_public_path__ + "hoop_v1.png";